<template>
    <modal id="prescription-imgpreview" v-model="modal" :append-to-body="true" size="max">
        <h4 slot="title" class="smalltitle">Preview File</h4>
        <div class="body">
            <iframe class="emr-pdf-preview img-preview" scrolling="auto"
                    :src="linkPreview"></iframe>
        </div>
        <div slot="footer">
            <div class="row">
                <div class="col-xs-6 text-left">
                    <!--                    <button type="button" class="btn light"><i class="fa fa-print"></i> Print</button>-->
                    <!--                    <button type="button" class="btn light" data-toggle="modal" data-target="ecntnote-send">-->
                    <!--                        <i class="fa fa-paper-plane"></i> Send to patient-->
                    <!--                    </button>-->
                </div>
                <div class="col-xs-6 text-right">
                    <!--                    <button type="button" class="btn btn-default"><i class="fa fa-sign-out-alt"></i>-->
                    <!--                        Transmit to Place-->
                    <!--                    </button>-->
                    <button type="button" class="btn btn-default" @click.prevent="modal = false">Close
                    </button>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import axios from '../client'
import config from '../config'
import Common from '../components/mixins/Common'
import { mapGetters } from 'vuex'

const mainUrl = config.mainUrl
export default {
  name: 'PreviewPdf',
  mixins: [Common],
  props: {
    linkPreview: {
      required: true
    }
  },
  data () {
    return {
      modal: false
    }
  },
  created () {
  },
  computed: {
    ...mapGetters({
      storeLocations: 'locations',
      storeStaffs: 'staffs',
      storeSelectedLocation: 'selectedLocation',
      storeSelectedStaff: 'selectedStaff',
      storeLocationObject: 'locationObject'
    })
  },
  destroyed () {
  },
  mounted () {
    this.modal = true
  },
  watch: {
    // bill: {
    //   handler: function (newVal, oldVal) {
    //     newVal.chooseBill = parseInt(newVal.chooseBill)
    //     this.$emit('updateBillData', newVal)
    //   },
    //   deep: true
    // },
    // 'patientId' (newVal, oldVal) {
    //   this.getBill()
    // }
    modal (newVal, oldVal) {
      this.$emit('updateModal', newVal)
    }
  },
  methods: {}

}
</script>
<style scoped>
 #prescription-imgpreview {
     z-index: 99999999999999 !important;
 }
</style>
